// startup
// Load entry module and return exports
__webpack_require__("../../packages/player/dist/style.css");
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./src/index.ts");
